<template>
  <div class="videos">
    <Submenu
      v-model="active_tab"
      v-show="Object.keys(routes).length > 1"
      @input="(v) => active_tab = v"
      :routes="routes"
      :prevent_routing="Array.isArray(tabs) && tabs.length > 0"
      :key="`${l.detect()}${$route.name}-${active_tab}`"
    />
    <VideoFragment
      v-if="$route.name === 'video.index' || (inside_modal && active_tab === 'video.index')"
      data-test-id="video-index"
    />
    <VideoUsersFragment
      v-if="$route.name === 'video.users.index' || (inside_modal && active_tab === 'video.users.index')"
      data-test-id="video-users-index"
    />
    <VideoUserInfo
      v-if="$route.name === 'video.users.show' || (inside_modal && active_tab === 'video.users.show')"
      data-test-id="video-users-show"
    />
    <VideoUserFragment
      v-if="$route.name === 'video.users.create' || (inside_modal && active_tab === 'video.users.create')"
      @created="changeTab('video.users.index')"
      data-test-id="video-users-create"
    />
  </div>
</template>

<script>
  import l from '../../../libs/lang';
  import VideoFragment from './index.vue';
  import VideoUserInfo from './users/show.vue';
  import VideoUsersFragment from './users/index.vue';
  import VideoUserFragment from './users/create.vue';
  import Submenu from '../../elements/Submenu.vue';

  export default {
    props: {
      tabs: {
        type: Array,
        default: null,
      },
    },
    components: {
      Submenu,
      VideoFragment,
      VideoUserInfo,
      VideoUserFragment,
      VideoUsersFragment,
    },
    data() {
      return {
        l,
        routes: this.prepare_routes(),
        inside_modal: this?.$parent?.$el?.role === 'dialog' || this?.$parent?.$el?.classList?.contains('v-dialog__content'),
        active_tab: null,
      };
    },
    beforeRouteLeave(to, from, next) {
      if (window.deleting_in_progress) {
        this.$emit('userRedirected', to, from, next);
      } else {
        next();
      }
    },
    methods: {
      prepare_routes() {
        const allowed_routes = {
          'video.index': { title: l.t('app.video-conferencing', 'Video conferencing') },
          'video.users.index': { title: l.t('app.users', 'Users'), subroutes: ['video.users.show'] },
          'video.users.create': { title: l.t('video.add-user', 'Add user') },
        };
        let routes = {};
        if (Array.isArray(this.$props.tabs) && this.$props.tabs.length) {
          for (const tab of this.$props.tabs) {
            if (allowed_routes[tab]) routes[tab] = allowed_routes[tab];
          }
        } else {
          routes = allowed_routes;
        }

        return routes;
      },
      changeTab(tab) {
        if (this.$props.tabs && this.$props.tabs.includes(tab)) {
          setTimeout(() => this.active_tab = tab, 2500);
        }
      }
    }
  };
</script>
